import { ReactElement } from "react";

import { List, useMediaQuery, useTheme } from "@mui/material";

import { generateSubMenuIdProps } from "components/Menu/accessibility.helpers";
import { useMenu } from "components/Menu/context";
import { MenuNodeType } from "components/Menu/model";

import { ContactMenu } from "../ContactMenu";
import { LanguageSelectionMenu } from "../LanguageSelectionMenu/LanguageSelectionMenu";
import { SubMenuNode } from "../SubMenuNode/SubMenuNode";

const customComponents: Record<
  MenuNodeType.CustomChildNodeComponent,
  (node: MenuNodeType.Container) => ReactElement
> = {
  changeLanguage: (node) => <LanguageSelectionMenu node={node} />,
  contactUs: (node) => <ContactMenu node={node} />,
};

export const SUB_MENU_DATA_TEST_ID = "sub-menu-nav";

export const SubMenuListItems = () => {
  const { subMenuModel, subMenuOpen } = useMenu();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (!subMenuOpen || !subMenuModel || !subMenuModel.childNodes) return null;

  if (subMenuModel.customChildNodeComponent) {
    return (
      <List
        component="nav"
        data-testid={SUB_MENU_DATA_TEST_ID}
        {...generateSubMenuIdProps({
          analyticsTag: subMenuModel.analyticsTag,
        })}
      >
        {customComponents[subMenuModel.customChildNodeComponent](subMenuModel)}
      </List>
    );
  }

  return (
    <List
      component="nav"
      data-testid={SUB_MENU_DATA_TEST_ID}
      {...generateSubMenuIdProps({
        analyticsTag: subMenuModel.analyticsTag,
      })}
    >
      {subMenuModel.childNodes.map((childNode, idx) => {
        return (
          <SubMenuNode
            childNode={childNode}
            key={`${childNode.titleKey}${childNode.nodeType}${idx}`}
            containerLinkText={subMenuModel.analyticsTag}
            isMobile={isMobile}
            focus={idx === 0}
          />
        );
      })}
    </List>
  );
};
